export enum GlobalType {
    TOOGLE_SIDER = 'global/toggle_sider',
}
